module.exports = new __parcel__URL__("Cleanroom.a5349f90.jpg").toString();